
import { computed, defineComponent } from "vue-demi";

export default defineComponent({
  name: "Popup",

  props: {
    to: {
      type: String,
      default: "root",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
    okLabel: {
      type: String,
      default: "Next",
    },
    okLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "ok", "cancel", "close"],

  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const onOk = () => {
      emit("ok");
    };

    const onCancel = () => {
      emit("cancel");
    };

    const onClose = () => {
      emit("close");
    };

    return {
      isOpen,
      onOk,
      onCancel,
      onClose,
    };
  },
});
